import React from 'react';
import { ConnectedPreviousSearchesMobile } from './PreviousSearchesMobile';
import { Config, LocationUtils } from '../../utils';

export function PreviousSearchesSourceMobile(options) {
    return {
        render: ({ onClickItem, displayedWord = '' } = {}) => {
            const { maxPreviousSearches, field, id, activeProduct, departureOrArrival } = options;
            const show = !LocationUtils.isKeywordLongEnoughAccordingWithLanguage(
                displayedWord,
                Config.get('autocompleteOptions'),
                activeProduct,
                departureOrArrival,
            );
            return (
                <ConnectedPreviousSearchesMobile
                    key="previous-searches"
                    maxLength={maxPreviousSearches}
                    onClickItem={onClickItem}
                    show={show}
                    field={field}
                    id={id}
                />
            );
        },
    };
}
